module.exports = ".center {\n  text-align: center; }\n\n.row {\n  margin: 10px; }\n\ntd {\n  padding: 5px; }\n\ntr > td:first {\n  padding-left: 15px; }\n\n.toggle {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  text-align: center; }\n\n.form-control {\n  padding: 0;\n  padding-left: 5px; }\n\n.clickable {\n  cursor: pointer; }\n\nselect.form-control {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/adjustments/components/vehicle-adjustments.component.scss
// module id = ./src/app/report/adjustments/components/vehicle-adjustments.component.scss
// module chunks = main